// Collapsible list of the driver's upcoming bookings. Rendered only when
// at least one item is provided. Each item links to that booking's own
// tracking URL in a new tab (the `driverJwt` field of the coming booking
// is the pre-signed URL returned by /track/coming/:uid/:token).

import React from "react";
import styled from "styled-components";
import { tokens } from "./tokens";
import { Icon, ICON_PATHS } from "./icons";

const Card = styled.div`
  background: ${tokens.colors.surface};
  border-radius: ${tokens.radii.md}px;
  border: 1px solid ${tokens.colors.border};
  box-shadow: ${tokens.shadows.card};
  padding: 10px 12px;
`;

const Summary = styled.summary`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  list-style: none;

  &::-webkit-details-marker {
    display: none;
  }
`;

const HeaderLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: ${tokens.colors.muted};
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 10px 0 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ItemLink = styled.a`
  display: block;
  color: ${tokens.colors.text};
  text-decoration: none;
  padding: 10px 12px;
  border: 1px solid ${tokens.colors.border};
  border-radius: ${tokens.radii.sm}px;
  background: ${tokens.colors.surfaceAlt};
`;

const ItemDate = styled.div`
  font-size: 13px;
  font-weight: 600;
`;

const ItemMeta = styled.div`
  font-size: 12px;
  color: ${tokens.colors.muted};
  margin-top: 2px;
`;

export default function UpcomingBookings({ bookings }) {
  if (!bookings || bookings.length === 0) return null;
  return (
    <Card>
      <details>
        <Summary>
          <HeaderLabel>Courses à venir ({bookings.length})</HeaderLabel>
          <Icon path={ICON_PATHS.chevronDown} size={16} sw={2} />
        </Summary>
        <List>
          {bookings.map((b) => (
            <li key={b.id || b.driverJwt}>
              <ItemLink
                href={b.driverJwt}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ItemDate>{b.pickup_date?.displayDate}</ItemDate>
                <ItemMeta>Départ de {b.pickup_address}</ItemMeta>
                {b.flight_number && <ItemMeta>Vol {b.flight_number}</ItemMeta>}
              </ItemLink>
            </li>
          ))}
        </List>
      </details>
    </Card>
  );
}
